
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import {connect} from 'react-redux'
import classnames from 'classnames'
import Icon from 'components/Icon'
import PropTypes from 'prop-types'
import {Link} from 'react-router'
import {
  fetchNotificationsData,
  fetchNotificationsSetupData,
  markNotification
} from 'redux/modules/notifications/actions'
import {
  getNotifyList,
  getNotifySetupList,
  getNotifyPageCurrent,
  getNotifyPageCount
} from 'redux/modules/notifications/selectors'
import xor from 'lodash/xor'
import union from 'lodash/union'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {showConfirm, closeConfirm} from 'redux/modules/ui/confirm/actions'
import Pager from 'components/Pager'
import Loader from 'components/Loader'
import {getSanitizedHtml} from 'utils/sanitizeHtml'

import InstallationStep from 'components/InstallationStep'
import List from 'components/List'
import CodeBlock from 'components/CodeBlock'

export class NotifyContent extends React.Component {
  static propTypes = {
    fetchNotificationsData: PropTypes.func,
    fetchNotificationsSetupData: PropTypes.func,
    markNotification: PropTypes.func,
    showConfirm: PropTypes.func,
    closeConfirm: PropTypes.func,
    closeModal: PropTypes.func,
    onFullPage: PropTypes.bool,
    showFilter: PropTypes.bool,
    notifications: PropTypes.array,
    notifications_setup: PropTypes.array,
    loading: PropTypes.bool,
    loadingSetup: PropTypes.bool,
    currentPage: PropTypes.number,
    maxPage: PropTypes.number
  }

  static defaultProps = {
    showFilter: true,
    notifications: []
  }
  constructor(props) {
    super(props)
    this.state = {
      expandedNotify: [],
      expandedADNotify: [],
      notifyFilterActive: 'All'
    }
  }
  componentDidMount() {
    const {fetchNotificationsSetupData} = this.props
    fetchNotificationsSetupData()
  }
  render() {
    return (
      <div className='notify_view'>
        <div className={classnames('notify_view-header')}>
          {this.renderFilter()}
          {this.renderViewAll()}
        </div>
        {this.renderInitial()}
        {this.renderItem()}
      </div>
    )
  }
  renderInitial() {
    const {loadingSetup, notifications_setup} = this.props
    if (!notifications_setup) return ''
    const {expandedNotify} = this.state
    if (notifications_setup.length == 0) return ''
    return (
      <div className='notify_view-list' key='setup'>
        <div className='notify_view-title'>Setup notifications</div>
        {loadingSetup ? (
          <div className='notify_view-loading'>
            <Loader />
          </div>
        ) : (
          ''
        )}
        {Object.keys(notifications_setup).map((key, index) => {
          const notify = notifications_setup[key]
          const expanded = expandedNotify.includes(notify._id)
          const expandClass = expanded ? ' expanded' : ''
          const level =
            notify.priority > 8
              ? ' low'
              : notify.priority > 5
                ? ' medium'
                : ' hight'
          return (
            <div
              className={'notify_view-item ' + level + expandClass}
              key={index}
            >
              <div className='notify_view-item-content'>
                {this.renderTitle(notify)}
                <div
                  className='notify_view-dropdown'
                  onClick={() => this.handleExpandClick(notify._id, expanded)}
                >
                  <Icon name='down' size='23px' className='' />
                </div>
                {this.renderButton(notify)}
              </div>
              <div className='notify_view-more'>
                {this.renderDetails(notify.details)}
              </div>
            </div>
          )
        })}
      </div>
    )
  }
  renderItem() {
    const {loading, notifications} = this.props
    const {expandedNotify} = this.state
    const {expandedADNotify} = this.state
    return (
      <div className='notify_view-list' key='need_attention'>
        <div className='notify_view-title'>Need attention</div>
        {loading ? (
          <div className='notify_view-loading'>
            <Loader />
          </div>
        ) : (
          ''
        )}
        {(!notifications || notifications.length == 0) && !loading ? (
          <div className='notify_view-empty'>
            There are no notifications at this moment
          </div>
        ) : (
          ''
        )}
        {Object.keys(notifications).map((key_ads, index_ads) => {
          const ads = notifications[key_ads]
          const expandedAD = expandedADNotify.includes(ads.adId)
          const expandADClass = expandedAD ? ' expanded' : ''
          const max_priority = ads.suggestions[0]
          const ad_level =
            max_priority.priority > 8
              ? ' low'
              : max_priority.priority > 5
                ? ' medium'
                : ' hight'
          return (
            <div
              className={'notify_view-ads ' + expandADClass + ad_level}
              key={index_ads}
            >
              {this.renderTitleADS(ads, expandedAD, max_priority)}
              <div className='notify_view-ads-content'>
                {Object.keys(ads.suggestions).map((key, index) => {
                  const notify = ads.suggestions[key]
                  const expanded = expandedNotify.includes(notify._id)
                  const expandClass = expanded ? ' expanded' : ''
                  const level =
                    notify.priority > 8
                      ? ' low'
                      : notify.priority > 5
                        ? ' medium'
                        : ' hight'
                  return (
                    <div
                      className={'notify_view-item ' + level + expandClass}
                      key={index + index_ads}
                    >
                      <div className='notify_view-item-content'>
                        {this.renderTitle(notify)}
                        <div
                          className='notify_view-dropdown'
                          onClick={() =>
                            this.handleExpandClick(notify._id, expanded)
                          }
                        >
                          <Icon name='down' size='23px' className='' />
                        </div>
                        {this.renderButton(notify)}
                      </div>
                      <div className='notify_view-more'>
                        {this.renderDetails(notify.details)}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
        {this.renderPaging()}
      </div>
    )
  }

  handleFilterClick = menu_key => {
    this.setState({
      notifyFilterActive: menu_key
    })
  }
  handleExpandClick = (notify_id, active) => {
    const {expandedNotify} = this.state

    if (active) {
      this.setState({
        expandedNotify: xor(expandedNotify, [notify_id])
      })
    } else {
      this.setState({
        expandedNotify: union(expandedNotify, [notify_id])
      })
    }
  }
  handleExpandAdClick = (ad_id, active) => {
    const {expandedADNotify} = this.state
    if (active) {
      this.setState({
        expandedADNotify: xor(expandedADNotify, [ad_id])
      })
    } else {
      this.setState({
        expandedADNotify: union(expandedADNotify, [ad_id])
      })
    }
  }

  hasActiveParameter() {
    const {expandedNotify} = this.state

    return Object.keys(expandedNotify).find(item => !!expandedNotify[item])
  }

  renderTitleADS(ad, expanded, max_priority) {
    return (
      <div className={'notify_view-ads-header'}>
        <div className='notify_view-ads-name'>
          <span className='notify_view-ads-title' title={`${ad.adName}`}>
            {`${ad.adName}`}
          </span>
          {this.renderStatusADS(ad)}
        </div>
        <div
          className='notify_view-addropdown'
          onClick={() => this.handleExpandAdClick(ad.adId, expanded)}
        >
          {!expanded ? this.renderMinSuggestion(ad, max_priority) : <span />}
          <Icon name='down' size='16px' className='' />
        </div>
      </div>
    )
  }
  renderStatusADS(ad) {
    const statusADClass = ad.adStatus == 'Active' ? ' active' : ''
    return (
      <span
        className={'notify_view-ads-status' + statusADClass}
        title='AD Status'
      >
        {`${ad.adStatus}`}
      </span>
    )
  }
  renderTitle(item) {
    switch (item.notificationType) {
      case 'alert':
      case 'comparison':
        return (
          <div className='notify_view-text'>
            <span>
              {`This ad is ${item.title.issue}`}
              <strong>{` | ${item.title.explanation}`}</strong>
            </span>
          </div>
        )
      default:
        return (
          <div className='notify_view-text'>
            <span
              dangerouslySetInnerHTML={{
                __html: `${getSanitizedHtml(item.message)}`
              }}
            />
          </div>
        )
    }
  }
  renderMinSuggestion(ad, max_priority) {
    const has_more_noti = ad.suggestions.length > 1
    const more_noti_class = !has_more_noti ? ' not_more_noti' : ''
    switch (max_priority.notificationType) {
      case 'alert':
      case 'comparison':
      case 'config':
        return (
          <span className='notify_view-issue'>
            <span className='notify_view-issue-text'>This ad is</span>
            <div
              className={'notify_view-min_issue ellipsis' + more_noti_class}
              title={max_priority.title.issue}
            >
              {`${max_priority.title.issue}`}
            </div>
            {has_more_noti ? (
              <div className='notify_view-min_issue more'>
                + {ad.suggestions.length - 1}
              </div>
            ) : (
              ''
            )}
          </span>
        )
      default:
        return (
          <span className='notify_view-issue'>
            <div
              className={
                'notify_view-min_issue ellipsis full' + more_noti_class
              }
              title={this.striptag(max_priority.message)}
            >
              {`${max_priority.message}`}
            </div>
            {has_more_noti ? (
              <div className='notify_view-min_issue more'>
                + {ad.suggestions.length - 1}
              </div>
            ) : (
              ''
            )}
          </span>
        )
    }
  }
  striptag(text) {
    return text.replace(/(<([^>]+)>)/gi, '')
  }
  renderFilter() {
    const {showFilter} = this.props
    if (!showFilter) {
      return <div />
    }
    const {notifyFilterActive} = this.state
    const menus = [
      {
        key: 'All',
        title: 'All'
      },
      {
        key: 'Unread',
        title: 'Unread'
      }
    ]
    return (
      <nav className='top-panel-menu'>
        {Object.keys(menus).map((key, index) => {
          const menu = menus[key]
          const expandClass = notifyFilterActive == menu.key ? 'is-active' : ''
          return (
            <div
              className={classnames('top-panel-menu_item', expandClass)}
              onClick={() => this.handleFilterClick(menu.key)}
              key={key}
            >
              {menu.title}
            </div>
          )
        })}
      </nav>
    )
  }

  renderDetails = details => {
    if (!details || !details.length) return null
    return details.map((detail, index) => {
      if (typeof detail === 'string') {
        return <p key={index} dangerouslySetInnerHTML={{__html: detail}} />
      }
      if (typeof detail === 'object') {
        const {type, value} = detail
        if (type === 'step') {
          return this.renderStep(value)
        } else if (type === 'list') {
          return this.renderList(value, index)
        } else if (type === 'image') {
          return this.renderImage(value, index)
        } else if (type === 'codeblock') {
          return this.renderCodeBlock(value, index)
        }
      }
    })
  }

  renderStep = values => {
    if (!values || !values.length) return null
    return values.map(({text, value: itemValues}, index) => (
      <InstallationStep
        number={index + 1}
        title={
          <span dangerouslySetInnerHTML={{__html: getSanitizedHtml(text)}} />
        }
        key={text}
      >
        {!!itemValues && this.renderDetails(itemValues)}
      </InstallationStep>
    ))
  }
  renderList = (values, index) => {
    if (!values || !values.length) return null
    return <List key={index} items={values} />
  }
  renderImage = (url, index) => {
    if (!url) return null
    return (
      <img key={index} className='editThemeImg' src={url} alt='detail-img' />
    )
  }
  renderCodeBlock = (code, index) => {
    if (!code) return null
    return <CodeBlock key={index} code={code} />
  }

  renderViewAll() {
    const {onFullPage, closeModal, notifications} = this.props
    if (!onFullPage && notifications && notifications.length > 0) {
      return (
        <div className='notify_view-link_all' onClick={closeModal}>
          <Link to={'/notifications'} onClick={() => closeModal()}>
            View all
            <Icon name='chevrons-double' size='16px' />
          </Link>
        </div>
      )
      return ''
    }
  }
  renderPaging() {
    const {notifications, currentPage, maxPage} = this.props
    if (!notifications || !notifications.length || !maxPage || maxPage < 2) { return null }
    return (
      <div className='notify_view-pager'>
        <Pager
          className='container'
          page={currentPage}
          max={maxPage}
          onPageSelect={this.onPageSelect}
        />
      </div>
    )
  }

  onPageSelect = page => {
    const {fetchNotificationsData} = this.props
    fetchNotificationsData(page)
  }
  renderButton(item) {
    switch (item.notificationType) {
      case 'initial':
        return (
          <div className='notify_view-button buttons-group_button'>
            <button
              type='button'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Close', item._id)
              }}
            >
              Close
            </button>
          </div>
        )
      case 'config':
      case 'default':
        return (
          <div className='notify_view-button buttons-group_button'>
            <button
              type='button'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Close', item._id)
              }}
            >
              Close
            </button>
            <button
              type='submit'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Done', item._id)
              }}
            >
              Done
            </button>
          </div>
        )
      case 'alert':
        return (
          <div className='notify_view-button buttons-group_button'>
            <button
              type='button'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Ignore', item._id)
              }}
            >
              Ignore
            </button>
            <button
              type='submit'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Done', item._id)
              }}
            >
              Done
            </button>
          </div>
        )
      case 'comparison':
        return (
          <div className='notify_view-button buttons-group_button'>
            <button
              type='button'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Ignore', item._id)
              }}
            >
              Ignore
            </button>
            <button
              type='submit'
              onClick={evt => {
                evt.stopPropagation()
                this.confirmNotify(item.notificationType, 'Done', item._id)
              }}
            >
              Done
            </button>
          </div>
        )
      default:
        return ''
    }
  }
  confirmNotify(notiType, type, notifyID) {
    const {markNotification, showConfirm, closeConfirm} = this.props
    const title = this.titleConfirm(type)

    const message = this.messageConfirm(notiType, type)
    showConfirm({
      title,
      message,
      ok: 'Ok',
      onOk: () => markNotification(type, notifyID),
      onCancel: () => closeConfirm()
    })
  }
  messageConfirm(notiType, type) {
    switch (notiType) {
      case 'initial':
        return (
          <p>
            Clicking Close means this notification will be removed and not
            showed again.
          </p>
        )

      case 'config':
        if (type === 'Done') {
          return (
            <p>
              Clicking Done will mark this notification as completed. We will
              remove it and not show it again. If you haven't taken any action,
              please click Close instead.{' '}
            </p>
          )
        } else {
          return (
            <p>
              Clicking Close means this notification will be removed and not
              showed again. If it is a notification you have acted on, please
              click Done instead.
            </p>
          )
        }

      default:
        if (type === 'Ignore') {
          return (
            <p>
              Clicking Ignore means this notification will be removed and not
              showed again. Use this if you didn't think the notification was
              relevant for you. If it is a notification you have acted on,
              please click Done instead.
            </p>
          )
        } else {
          return (
            <p>
              Clicking Done will mark this notification as completed. We will
              remove it and not show it again. If you haven't taken any action
              but want to remove the notification, please click Ignore instead.
            </p>
          )
        }
    }
  }
  titleConfirm(type) {
    switch (type) {
      case 'Ignore':
      case 'Close':
        return <span>Mark this notification as {type}d</span>
      default:
        return <span>Mark this notification as {type}</span>
    }
  }
}

const mapStateToProps = state => {
  return {
    notifications: getNotifyList(state),
    notifications_setup: getNotifySetupList(state),
    currentPage: getNotifyPageCurrent(state),
    maxPage: getNotifyPageCount(state),
    loading: state.notifications.isFetching,
    loadingSetup: state.notifications.isFetchingSetup
  }
}
export default connect(mapStateToProps, {
  fetchNotificationsData,
  fetchNotificationsSetupData,
  markNotification,
  showConfirm,
  closeConfirm,
  closeModal
})(NotifyContent)



// WEBPACK FOOTER //
// ./client/components/NotifyContent/index.js